var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 18.712,
    height: 30.939,
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896",
    transform: "translate(71 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    transform: "translate(-71 3)",
    fill: "#fff",
    stroke: "#76a94b",
    strokeWidth: 1,
    strokeDasharray: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    transform: "translate(-57.356 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M66.924,35.932c-.707-1.454-1.451-2.882-2.292-4.27-1.157-1.911-.908-4.031-.568-6.121.041-.253.32-.331.475-.5a2.953,2.953,0,0,0,.73-3.217q-.087-.077-.054-.149c.022-.047.043-.071.063-.071.4-.047.633.052.614.537a4.021,4.021,0,0,1-1.146,3.243.768.768,0,0,0-.31.495c-.332,2.112-.464,4.174.837,6.079a13.846,13.846,0,0,1,1.861,3.7c.1.22-.008.283-.21.27",
    transform: "translate(-50.741 -17.18)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M12.888,142.591a7.75,7.75,0,0,0,2.828.4c.151-.11.213-.326.429-.359.541-.117.949-.573,1.443.412.386.77,1.7.53,2.653.385.68-.1,1.153-.357,1.028-1.159.43-.36.743-.117,1.04.2.03.191-.084.278-.241.334-.652-.225-.3.548-.725.7-1.33.488-2.757.77-3.884-.03-.71-.5-.915-.356-1.593-.122a3.554,3.554,0,0,1-2.989-.541q-.088-.08-.054-.154c.022-.048.044-.072.065-.072",
    transform: "translate(-10.194 -113.044)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M79.159,90.678l.21-.27a27.268,27.268,0,0,1,2.306,8.755,1,1,0,0,1-.5,1.119.251.251,0,0,1-.213-.21c.685-.808.218-1.693.1-2.514a34.034,34.034,0,0,0-1.906-6.881",
    transform: "translate(-62.976 -71.925)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M19.9,37.763a8.248,8.248,0,0,1-2.044,4.23.231.231,0,0,1-.055-.331,28.387,28.387,0,0,1,1.274-2.668,4.449,4.449,0,0,0,.233-3.675,9.146,9.146,0,0,0-1.3-2.508.243.243,0,0,1,.059-.343A5.609,5.609,0,0,1,19.9,36.292a3.44,3.44,0,0,1,0,1.47",
    transform: "translate(-14.126 -25.83)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M2.694,118.448c0,.075-.008.151-.011.226-.267-.023-.545-.312-.522-.4.281-1.116-.618-.873-1.144-1a1.121,1.121,0,0,1-1.011-1.333,29.25,29.25,0,0,1,.659-4.2c.4.016.245.276.211.482-.142,1.131-.252,2.267-.437,3.391-.156.948.333,1.321,1.147,1.336s1.386.092.99,1.123c-.036.094.075.246.118.371",
    transform: "translate(0 -88.9)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M16.712,8.811l-.059.343c-.889-1.463-.815-2.008.406-2.983A1.407,1.407,0,0,0,17.5,4.306c-.208-.491-.8-.913-.447-1.575.66-.015.864.372.842.958-.425.3.015.563.1.77a1.316,1.316,0,0,1-.4,1.732c-1.251.636-1.195,1.546-.88,2.62",
    transform: "translate(-12.772 -2.173)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M37.091,14.67a4.46,4.46,0,0,0-.562,1.715.683.683,0,0,1-.664.743.8.8,0,0,1-.944-.574,5.172,5.172,0,0,0-1.947-2.7c-.039-.22.008-.351.269-.26a5.47,5.47,0,0,1,1.991,2.666c.114.333.232.425.545.417.348-.008.36-.259.386-.489a2.877,2.877,0,0,1,.7-1.755c.2-.031.3.025.223.242",
    transform: "translate(-26.223 -10.787)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M65.286,5.635c0,.073-.007.146-.01.22-1.574-.52-1.524-1.788-1.421-3.081a.241.241,0,0,1-.054-.241,6.664,6.664,0,0,1,.553-.9c.108-.082.218-.157.359-.071.235.126.094.273.019.411-.748,1.364-.771,2.616.554,3.665",
    transform: "translate(-50.748 -1.21)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M3.464,96.02c-.028-.179-.035-.367-.211-.482a18.359,18.359,0,0,1,1.575-4.165.273.273,0,0,1,.068.372L3.464,96.02",
    transform: "translate(-2.588 -72.693)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M76.694,137.685l.213.21c-.761.881-2.04.843-2.864,1.614-.094-.061-.225-.078-.255-.216.737-.953,2.012-.937,2.905-1.608",
    transform: "translate(-58.704 -109.537)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M61.291,144.606l.255.216c-1.188.476-2.373.916-3.466-.207l.242-.2a.187.187,0,0,1,.193-.037c.072.077.1.186.179.258a3.8,3.8,0,0,0,2.6-.028",
    transform: "translate(-46.206 -114.85)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M11.023,80.659l-.068-.372a11.482,11.482,0,0,1,1.437-2.849l.055.331a9.451,9.451,0,0,1-1.423,2.889",
    transform: "translate(-8.715 -61.608)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M59.306,1.388a1.415,1.415,0,0,1,.008.174c-.493.253-.7.847-1.233,1.049.251-.889.986-1.522,1.234-2.444.108-.4.576.02.856.181l-.307.305c-.334.133-.338.516-.559.735",
    transform: "translate(-46.208 0.001)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M21.765,2.342c-.24-.356-.392-.788-.842-.958.5-.462.85-.547,1.056.281a4.76,4.76,0,0,0,.634,1.125.363.363,0,0,1-.032.491c-.4-.2-.567-.606-.815-.939",
    transform: "translate(-16.646 -0.826)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M52.295,14.622l-.223-.242c.36-.336.411-1.143,1.217-.8l-.995,1.037",
    transform: "translate(-41.427 -10.739)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M29.032,10.1q.016-.245.031-.491l1.053.837-.269.26c-.273-.2-.664-.241-.815-.606",
    transform: "translate(-23.097 -7.645)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M34.531,101.446c-.062-1.551.189-3.085.259-4.628.536.411.225.953.224,1.447q-.14,2.425-.281,4.851c-.544-.5-.192-1.106-.2-1.67",
    transform: "translate(-27.39 -77.025)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M28.541,116.451a7.854,7.854,0,0,1,.661-3.332l-.47,4.4c-.533-.271-.194-.7-.19-1.066",
    transform: "translate(-22.619 -89.994)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M68.89,109.751a11.206,11.206,0,0,1,.656,4.015l-.868-3.566c-.061-.212-.176-.45.212-.449",
    transform: "translate(-54.587 -87.314)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M15.611,104.217a29.27,29.27,0,0,1-.669,3.421c-.4-.012-.249-.263-.207-.468a21.177,21.177,0,0,1,.663-3.4c.389-.006.268.234.213.443",
    transform: "translate(-11.674 -82.559)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M52.337,116.465c.443.619.172,1.336.276,2,0,.36.32.785-.213,1.035l-.206-3.04c.05-.1.1-.1.144,0",
    transform: "translate(-41.523 -92.595)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M27.828,129.419c.129.343-.1.752.19,1.066q-.1.8-.2,1.606c-.507-.035-.182-.38-.22-.589a7.2,7.2,0,0,1,.225-2.082",
    transform: "translate(-21.906 -102.961)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M36.3,94.063c-.215-.461.159-1.013-.224-1.447a1.594,1.594,0,0,1,.154-1.08c.187.09.084.313.2.436a6.419,6.419,0,0,1-.129,2.091",
    transform: "translate(-28.675 -72.823)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M18.43,98.9c-.073-.146-.012-.358-.213-.443a1.982,1.982,0,0,1,.594-1.366L18.43,98.9",
    transform: "translate(-14.493 -77.243)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M50.732,92.925l.054,1.538a2.429,2.429,0,0,1,.062.991.162.162,0,0,1-.262.081l-.059-1.409c-.014-.415-.317-.879.205-1.2",
    transform: "translate(-40.117 -73.928)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M51.132,105.7a1.419,1.419,0,0,0,.165.054c.243.208-.007.547.2.764a3.83,3.83,0,0,1-.022,1.444h-.072l-.072,0a15.218,15.218,0,0,1-.2-2.259",
    transform: "translate(-40.663 -84.087)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M50.44,90.075c-.322.357-.045.817-.205,1.2a2.816,2.816,0,0,1-.006-1.934c.347.227.248.487.211.732",
    transform: "translate(-39.826 -71.078)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M34.3,119.458c.205.54-.168,1.15.2,1.67a1.829,1.829,0,0,1-.114.937c-.282-.171-.058-.5-.228-.711a5.176,5.176,0,0,1,.14-1.9",
    transform: "translate(-27.163 -95.037)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M34.047,128.731c.225.189.153.474.228.711q-.052.783-.1,1.567a6.557,6.557,0,0,1-.124-2.277",
    transform: "translate(-27.046 -102.414)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M67.967,105.147c-.2.089-.154.294-.212.449a2.484,2.484,0,0,1-.262-1.632,2.185,2.185,0,0,1,.474,1.183",
    transform: "translate(-53.663 -82.71)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M27.185,139.6c.083.193,0,.448.22.589q.017.231.034.462c-.093.18-.195.349-.429.359.081-.467-.09-.966.175-1.41",
    transform: "translate(-21.488 -111.063)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M75.4,133.318c-.423-.553-.629-.953-.316-1.476l.316,1.476",
    transform: "translate(-59.613 -104.889)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M14.034,120.385l.207.468-.223,1.016c-.228.015-.255-.11-.2-.291a2.181,2.181,0,0,1,.219-1.194",
    transform: "translate(-10.972 -95.774)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M65.4,97.273c.471.229.315.7.428,1.091-.46-.225-.24-.734-.428-1.091",
    transform: "translate(-52.029 -77.387)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M55.6,113.422h-.216c-.167-.281-.28-.562.009-.838.267.231.227.537.207.839",
    transform: "translate(-43.927 -89.567)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M13.232,126.224l.2.291-.261,1.086a1.652,1.652,0,0,1,.057-1.377",
    transform: "translate(-10.39 -100.419)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M28.239,52.646l0-1.47a1.662,1.662,0,0,1,0,1.47",
    transform: "translate(-22.464 -40.714)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M37.154,89.056l-.2-.436a.947.947,0,0,1,.2-.749Z",
    transform: "translate(-29.4 -69.906)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M20.2,92.926c-.146-.31-.047-.5.255-.626a.418.418,0,0,1-.255.626",
    transform: "translate(-16.016 -73.431)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M60.176,133.813a.992.992,0,0,1-.141-.127q-.028-.476-.055-.952c.372.3.2.708.2,1.08",
    transform: "translate(-47.718 -105.598)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M64.071,3.863c.187-.244-.127-.869.559-.735-.213.225-.163.649-.559.735",
    transform: "translate(-50.973 -2.474)",
    fill: "#76a94b",
    stroke: "#76a94b",
    strokeWidth: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariety);
export default __webpack_public_path__ + "static/media/variety.c52c13266eca7aedf1c1fdf899e9a8b1.svg";
export { ForwardRef as ReactComponent };